import styles from "./ResultsList.module.css";
import { Box, Checkbox } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import highlighter, { keyExists } from "../../utils/highliter";
import FixedTopParent from "./FixedTopParent";
import DropInfo from "./DropInfo";
import CheckedIcon from "../../Icons/CheckedMark";
import jsonDB from "../../Hintsdata.json";

const LabelTree = ({ item, handleCachedItem, caches, searchKey, setSticked }) => {
  const currentItem = caches.find((i) => i.code === item.code);

  const [checked, setChecked] = useState(!!currentItem);
  const handleCheckedItem = () => setChecked(handleCachedItem(item, !checked));

  const ref = useRef();

  useEffect(() => {
    setChecked(!!currentItem);
  }, [caches]);

  const hint = getHint(item);
  const [openHint, setOpenHint] = useState(false);

  useEffect(() => {
    if (hint.hasContent) setOpenHint(keyExists(searchKey, hint.all));
  }, []);

  return (
    <FixedTopParent
      item={item}
      setSticked={setSticked}
      isParent={!item.parentid}
      parentRef={ref}
    >
      <div
        ref={ref}
        className={styles["cpv-search-item"]}
        onClick={(e) => e.stopPropagation()}
      >
        <Checkbox
          sx={{ "& .MuiSvgIcon-root": { fontSize: "1.5em" } }}
          className={styles["cpv-search-checkbox"]}
          checked={checked}
          onChange={() => handleCheckedItem(item)}
          onClick={(e) => e.stopPropagation()}
          disableRipple
          checkedIcon={<CheckedIcon />}
        />
        <Box sx={{ width: "100%" }}>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => handleCheckedItem(item)}
          >
            {!item.parentid && getDepartmentLabel(item.code)}

            <div className={styles["cpv-search-itemContent"]}>
              <strong
                dangerouslySetInnerHTML={{
                  __html: highlighter(searchKey, item.code),
                }}
              />
              <span
                dangerouslySetInnerHTML={{
                  __html: highlighter(searchKey, item.description),
                }}
              />
              {hint.hasContent && (
                <span className={styles["cpv-search-dropper"]}>
                  <div
                    className={styles["cpv-search-infoMark"]}
                    onClick={() => setOpenHint(!openHint)}
                  >
                    i
                  </div>
                </span>
              )}
            </div>
          </span>
        </Box>
      </div>
      {hint.hasContent && (
        <DropInfo content={hint} searchKey={searchKey} open={openHint} />
      )}
    </FixedTopParent>
  );
};

const getDepartmentLabel = (code) => {
  code = parseFloat(code.replace("-", "."));
  let styles = {
    color: "#0a717c",
    fontSize: "0.75em",
    marginLeft: "5px",
    borderRadius: "4px",
    paddingRight: "5px",
    paddingLeft: "5px",
    paddingTop: "6px",
    paddingBottom: "4px",
  };

  if (code <= 44000000)
    return (
      <span style={{ ...styles, backgroundColor: "#cce8ec" }}>
        Lieferleistungen
      </span>
    );
  if (code >= 48000000)
    return (
      <span style={{ ...styles, backgroundColor: "#cce8ec" }}>
        Dienstleistungen
      </span>
    );
  if (code === 45000000)
    return (
      <span style={{ ...styles, backgroundColor: "#cce8ec" }}>
        Bauleistungen
      </span>
    );
};

const getHint = (item) => {
  const hinweise = jsonDB.HintsData.find((v) =>
    item.code.startsWith(v.code)
  )?.hint;
  const synonyme = item.synonyme;
  return {
    hinweise,
    synonyme,
    all: hinweise + synonyme,
    hasContent: hinweise?.length > 0 || synonyme?.length > 0,
  };
};

export default LabelTree;
